import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showToast } from "./toastAction";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { uploadImages, uploadSingleImage } from "../../utils/uploadFiles";

const getServices = (setLoading) => async (dispatch) => {
    if (setLoading) {
        setLoading(true);
    }

    const res = await api("get", Constants.END_POINT.SERVICES);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.SERVCIES,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
};

const getSubServices = (setLoading, subServiceId) => async (dispatch) => {
    if (setLoading) {
        setLoading(true);
    }
    // Initialize query parameters
    const queryParams = new URLSearchParams();

    queryParams.append("service", subServiceId);

    const res = await api("get", Constants.END_POINT.SERVICES + "?" + queryParams.toString());
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.SUB_SERVCIES,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
};

const getService = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.SERVICES + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.SERVICE_DETAILS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const addService = (data, setLoading, history) => async (dispatch) => {
    // setLoading(true);
    const serviceData = { ...data };

    for (let key in serviceData) {
        if (serviceData[key] instanceof File) {
            const image = await uploadSingleImage(serviceData[key]);
            serviceData[key] = image[0] ?? "";
        }
        if (Array.isArray(serviceData[key]) && serviceData[key][0] instanceof File) {
            const image = await uploadImages(serviceData[key]);
            serviceData[key] = image[0] ?? "";
        }
        if (key === "benefits") {
            for (let ben of serviceData[key]) {
                if (ben.iconImage) {
                    const image = await uploadImages(ben.iconImage);
                    ben.iconImage = image[0] ?? "";
                }
            }
        }
    }

    const res = await api("post", Constants.END_POINT.ADD_SERVICE, serviceData);
    if (res.success) {
        getServices(null);
        history.go(-2);
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    setLoading(false);
};

const updateService = (id, data, history) => async (dispatch) => {
    dispatch(showLoaderAction());
    const serviceData = { ...data };
    for (let key in serviceData) {
        if (serviceData[key] instanceof File) {
            const image = await uploadSingleImage(serviceData[key]);
            serviceData[key] = image[0] ?? "";
        }
        if (Array.isArray(serviceData[key]) && serviceData[key][0] instanceof File) {
            const image = await uploadImages(serviceData[key]);
            serviceData[key] = image[0] ?? "";
        }
        if (key === "benefits") {
            for (let ben of serviceData[key]) {
                if (Array.isArray(ben.iconImage) && ben.iconImage.length) {
                    if (ben.iconImage[0] instanceof File) {
                        const image = await uploadImages(ben.iconImage);
                        ben.iconImage = image[0] ?? "";
                    } else {
                        ben.iconImage = ben.iconImage[0] ?? "";
                    }
                }
            }
        }
    }
    const res = await api("put", Constants.END_POINT.SERVICES + id, serviceData);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            getServices(null);
            history.go(-2);
            dispatch(showToast({ severity: "success", summary: res.message }));
        }
    }
    dispatch(hideLoaderAction());
};

const deleteService = (data) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.SERVICES + data?._id);
    if (res.success) {
        if (data.service) {
            dispatch(getSubServices(null, data.service));
        } else {
            dispatch(getServices());
        }
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const createServiceItem = (data, additionalItemType, setVisible, resetItemForm) => async (dispatch) => {
    dispatch(showLoaderAction());
    const itemData = { ...data };

    let res;
    if (additionalItemType === "ITEM") {
        res = await api("post", Constants.END_POINT.ADD_ITEM, itemData);
    } else {
        res = await api("post", Constants.END_POINT.ADD_ADDITIONAL_SERVICE, itemData);
    }

    if (res.success) {
        resetItemForm();
        dispatch(getService(itemData.service));
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    setVisible(false);
    dispatch(hideLoaderAction());
};

const updateServiceItem = (id, data, additionalItemType, setVisible, resetItemForm) => async (dispatch) => {
    dispatch(showLoaderAction());
    const itemData = { ...data };

    let res;
    if (additionalItemType === "ITEM") {
        res = await api("put", Constants.END_POINT.SERVICE_ITEM + id, itemData);
    } else {
        res = await api("put", Constants.END_POINT.ADDITIONAL_SERVICE + id, itemData);
    }
    if (res.success) {
        if (res.data) {
            resetItemForm();
            dispatch(getService(itemData.service));
            dispatch(showToast({ severity: "success", summary: res.message }));
        }
    }
    setVisible(false);
    dispatch(hideLoaderAction());
};

const deleteServiceItem = (id, serviceId) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.SERVICE_ITEM + id);
    if (res.success) {
        dispatch(getService(serviceId));
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const deleteAddtionalService = (id, serviceId) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.ADDITIONAL_SERVICE + id);
    if (res.success) {
        dispatch(getService(serviceId));
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export {
    getServices,
    getService,
    updateService,
    addService,
    deleteService,
    createServiceItem,
    deleteServiceItem,
    deleteAddtionalService,
    updateServiceItem,
    getSubServices,
};
